import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private loadingCount = 0;
  private loadingState = signal<boolean>(false);

  /**
   * Returns the current loading state as a signal
   */
  public loading = this.loadingState.asReadonly();

  /**
   * Starts the loading state
   * Increments the loading counter and sets the loading state to true
   */
  public start(): void {
    this.loadingCount++;
    this.updateState();
  }

  /**
   * Stops the loading state
   * Decrements the loading counter and sets the loading state to false if the counter is 0
   */
  public stop(): void {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }
    this.updateState();
  }

  /**
   * Resets the loading state
   * Sets the loading counter to 0 and the loading state to false
   */
  public reset(): void {
    this.loadingCount = 0;
    this.updateState();
  }

  /**
   * Updates the loading state based on the loading counter
   */
  private updateState(): void {
    this.loadingState.set(this.loadingCount > 0);
  }
}
